/*
 * @Author: lishiqiao
 * @Date: 2022-09-07 14:45:36
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-09-08 10:09:33
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function getBaseListsByUser() {
    const url = '/baseData/queryBaseDataListByRole';
    return http.get(url);
}

// 获取养殖场下所有养殖区域
export function queryBaseGroupList(baseId) {
    const param = {
        baseId,
        groupFlag: 0
    }
    const url = '/baseGroup/queryBaseGroupList';
    return http.post(url, param)
}

// 根据当前机构id获取顶级机构id（为了获取养殖品种）
export function getOrgInfoByOrgId(orgId) {
    const url = '/org/getParentOrg/' + orgId;
    return http.get(url)
}

// 根据顶级机构id获取到养殖品种
export function getBreedCategory(orgId) {
    const url = '/breedData/getListMap/orgId/' + orgId;
    return http.get(url)
}


// 根据养殖区域获取养殖单元
export function listDataPermissionBoxData(groupId) {
    const url = '/boxData/listDataPermissionBoxData/' + groupId;
    return http.get(url)
}

// 获取所有可用养殖品类
export function getBreedTypeList(baseId) {
    const url = '/breedData/getBreedType/' + baseId;
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-02 15:45:30
 * @description: 养成育苗成本统计明细表分页
 * @param {*} params
 */
export function getPageOfCostRecordsDetails(params) {
    const url = '/checkBatchDay/getCheckBatchDayListMap';
    return http.post(url, params);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-02 15:40:33
 * @description: 获取成本统计明细表-操作类型下拉列表
 */
export function getCostOfTypeList() {
    const url = '/checkBatchDay/getOperationType';
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-09-08 09:48:40
 * @description: 育苗成本统计明细表-育苗批次
 * @param {*} baseId
 */
export function getSeedlingDataList(baseId) {
    const url = '/eggRecord/getBatchNumber/' + baseId;
    return http.get(url);
}